import React, { useEffect, useState } from "react";
import EditModal from "@core/modals/EditModal";
import EditButton from "@core/buttons/atoms/EditButton";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import SubStrataService from "@services/SubStrataService";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import StrataSelect from "@components/Strata/partials/StrataSelect";

const EditSubStrata = ({ subStrata, onEdited }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [strataId, setStrataId] = useState("");
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
    setStrataId("");
  };

  useEffect(() => {
    if (showModal)
      SubStrataService.find(subStrata.id).then((response) => {
        setName(response.data.data.name);
        setEnglishName(response.data.data.name_eng);
        setDescription(response.data.data.description);
        setStrataId(response.data.data.stratum_id);
      });
  }, [subStrata.id, showModal]);

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    SubStrataService.update(
      subStrata.id,
      name,
      englishName,
      strataId,
      description
    )
      .then(() => {
        showSuccess(t("subStrataEditedSuccessfully"));
        onEdited();
        closeModal();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PermissionHandler permission={"update_sub_stratum"}>
      <EditButton onClick={() => setShowModal(true)} />
      <EditModal
        show={showModal}
        title={t("editSubStrata")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
        label={t("edit")}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5 sm:gap-10">
          <Input
            height="h-10"
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <div>
            <div className="text-sm font-semibold mb-2">{t("strata")}</div>
            <StrataSelect
              openModal={showModal}
              selected={strataId}
              onSelect={setStrataId}
            />
          </div>
        </div>
      </EditModal>
    </PermissionHandler>
  );
};

export default EditSubStrata;
